import { useState } from 'react';

import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';

import { useLocale } from 'context/locale-context';

import { User } from 'shared/interfaces';
import { useClinics } from 'context/clinics-context';

interface ExportTableProps {
  users: User[];
}

const ExportTable = ({ users }: ExportTableProps) => {
  const { getLocaleOption } = useLocale();

  const [exporting, setExporting] = useState(false);
  const { clinics } = useClinics();

  const exportHandler = async () => {
    if (!exporting) {
      setExporting(true);

      const csv = [
        [
          getLocaleOption('firstName'),
          getLocaleOption('lastName'),
          getLocaleOption('username'),
          getLocaleOption('assignedClinics'),
          getLocaleOption('birthday'),
          getLocaleOption('registrationDate'),
          getLocaleOption('status'),
          getLocaleOption('questionnaireSubmittedOn'),
          getLocaleOption('partnerKey'),
        ],
      ];

      users.forEach((user) => {
        const { username, person, createdOn, userState, questionnaireFinishDate } = user;

        const raw = [
          person?.firstName || '',
          person?.lastName || '',
          username,
          clinics.find((clinic) => clinic.id === user?.clinicId)?.name || '',
          person?.birthday || '',
          new Date(createdOn).toISOString(),
          userState || '',
          questionnaireFinishDate?.toString().slice(0, 10) || '',
        ];

        csv.push(raw);
      });

      try {
        let blob = new Blob([csv.map((e) => e.join(';')).join('\n')], {
          type: 'text/csv;charset=utf-8;',
        });
        let link = document.createElement('a');
        if (link.download !== undefined) {
          var url = URL.createObjectURL(blob);
          link.setAttribute('href', url);
          const date = new Date();
          link.setAttribute(
            'download',
            [
              ('0' + date.getDate()).slice(-2),
              ('0' + (date.getMonth() + 1)).slice(-2),
              date.getFullYear(),
            ].join('-') + '.csv'
          );
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } catch (e) {}

      setExporting(false);
    }
  };

  return (
    <div className='export-users'>
      <Button
        type='button'
        icon='pi pi-file-excel'
        className='p-button-success mr-2'
        data-pr-tooltip='Export Table'
        onClick={exportHandler}
      />
      <Tooltip target='.export-users>button' position='bottom' />
    </div>
  );
};

export default ExportTable;
